import { find, some } from 'lodash'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { getProductPriceTitle } from '@/helpers'
import { isIPad, isMobile } from '@/helpers/variables'

export default {
  name: 'ProductPriceGrid',
  props: {
    /**
     * @type {ProductPrice[]}
     */
    clientPrices: {
      required: true,
      default: () => [],
    },
    product: {
      required: true,
      default: () => [],
    },
  },
  data() {
    return {
      windowWidth: window.innerWidth,
      timeRemaining: null,
      timerInterval: null,
    }
  },
  mounted() {
    window.addEventListener('resize', () => {
      this.windowWidth = window.innerWidth
    })
    this.startTimer()
  },
  beforeDestroy() {
    window.removeEventListener('resize', () => {
      this.windowWidth = window.innerWidth
    })
    this.stopTimer()
  },
  watch: {
    currentSelectProductPrice: {
      handler() {
        this.stopTimer()
        this.startTimer()
      },
      deep: true,
    },
  },
  computed: {
    ...mapGetters({
      isDistributor: 'profile/isDistributor',
      isProfessional: 'profile/isProfessional',
      isUserWithCode: 'profile/isUserWithCode',
      productLoading: 'card/productLoading',
      favourites: 'favorites/whichList',
      basket: 'basket/basket',
      productsWithDefaultPrices: 'basket/productsWithDefaultPrices',
      user: 'profile/user',
      isAuthenticated: 'auth/isAuthenticated',
      showNotifyLoader: 'products/showNotifyLoader',
      currentRegionCurrency: 'regions/currentRegionCurrency',
    }),
    isOtherRegion() {
      return localStorage.getItem('country') === 'OTHER'
    },
    showIndividualDiscountColumn() {
      const hasIndividualDiscount = this.product.productPrices.data.some((productPrice) => productPrice.hasIndividualDiscount)
      const hasActivePromotion = this.product.productPrices.data.some((productPrice) => productPrice.hasActivePromotion)
      console.log('pp data ', this.product.productPrices.data)
      return !!((this.isProfessional && hasIndividualDiscount) || (this.isProfessional && hasActivePromotion))
    },
    showClientPriceColumn() {
      const showClientPrice = this.clientPrices.some((productPrice) => productPrice.typeVisible && !productPrice.showWithoutPrice)
      return showClientPrice && this.isProfessional
    },
    currentSelectProductPrice() {
      const volume = parseInt(this.$route.query.value)

      return this.product.productPrices.data.find((item) => {
        return item.value == volume
      })
    },
    hasSaleTimer() {
      return this.currentSelectProductPrice &&
             this.currentSelectProductPrice.saleActiveTo &&
             this.timeRemaining &&
             this.timeRemaining.total > 0 &&
             (this.timeRemaining.days > 0 || this.timeRemaining.hours > 0 || this.timeRemaining.minutes > 0 || this.timeRemaining.seconds > 0)
    },
  },
  methods: {
    calculateTimeRemaining() {
      if (!this.currentSelectProductPrice || !this.currentSelectProductPrice.saleActiveTo) {
        this.timeRemaining = null
        return
      }

      const endDate = new Date(this.currentSelectProductPrice.saleActiveTo)
      const now = new Date()
      const total = endDate - now

      if (total <= 0) {
        this.timeRemaining = {
          total: 0,
          days: 0,
          hours: 0,
          minutes: 0,
          seconds: 0,
        }
        this.stopTimer()
        return
      }

      const seconds = Math.floor((total / 1000) % 60)
      const minutes = Math.floor((total / 1000 / 60) % 60)
      const hours = Math.floor((total / (1000 * 60 * 60)) % 24)
      const days = Math.floor(total / (1000 * 60 * 60 * 24))

      this.timeRemaining = {
        total,
        days,
        hours,
        minutes,
        seconds,
      }
    },
    startTimer() {
      this.calculateTimeRemaining()
      if (this.timeRemaining && this.timeRemaining.total > 0) {
        this.timerInterval = setInterval(() => {
          this.calculateTimeRemaining()
        }, 1000)
      }
    },
    stopTimer() {
      if (this.timerInterval) {
        clearInterval(this.timerInterval)
        this.timerInterval = null
      }
    },
    isOutlet(productPrice) {
      return productPrice.outletReasons && productPrice.outletReasons.data && productPrice.outletReasons.data.length > 0;
    },
    isSelectedPrice(productPrice) {
      if (this.$route.query.priceId) {
        return parseInt(this.$route.query.priceId) === parseInt(productPrice.id)
      }
      return parseInt(this.$route.query.value) === parseInt(productPrice.value)
    },
    selectProductPrice(productPrice) {
      if (this.isSelectedPrice(productPrice)) return

      this.$emit('change-product', productPrice)

      this.$router.replace({
        query: {
          ...this.$route.query,
          value: productPrice.value,
          priceId: productPrice.id
        }
      })
    },
    formatPriceValue(productPrice, field) {
      if (productPrice && !productPrice.typeVisible) return ''
      if (!productPrice) return ''
      return productPrice[field] + ` ${this.$currency(this.currentRegionCurrency)}`
    },
    formatCurrentPriceValue(field) {
      if (this.currentSelectProductPrice && !this.currentSelectProductPrice.typeVisible) return ''
      if (!this.currentSelectProductPrice) return ''
      return this.currentSelectProductPrice[field].toFixed(2) + ` ${this.$currency(this.currentRegionCurrency)}`
    },
    currentPriceValueAvailable(productPrice) {
      return productPrice && productPrice.typeVisible
    },
    isMobile() {
      return isMobile.any() || isIPad.iOS()
    },
  },
}
